<div class="highlight" *ngIf="config">
  <div class="chart" [id]="id"></div>
</div>